const map = {
	"./IMG_6845.jpg": 657,
	"./IMG_7223.jpg": 344,
	"./IMG_7224.jpg": 507,
	"./IMG_7225.jpg": 94,
	"./View recent photos.png": 605,
	"./ba5c1875-7dad-488b-8190-3731145013c1.JPG": 633,
	"./stickers.jpeg": 567
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 508;